import config from '@/config';
import api from '@/shared/api';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export const WEEK_PLANNER_UNPLANNED_TASKS_PAGE_SIZE = 10;
export const useGetWeekPlannerUnplannedTasks = (filters, enabled) => {
    var _a, _b;
    const intl = useIntl();
    const anyLevelSelected = ((_a = filters.taskLevels) !== null && _a !== void 0 ? _a : []).length > 0;
    const { data, isLoading, isFetching, isFetchingNextPage, error, refetch, fetchNextPage, hasNextPage, } = useInfiniteQuery([TaskQueryKey.WeekPlannerUnplannedTasks, filters], ({ pageParam = 0 }) => api.base
        .get(`${config.appUrls.tasks}/api/WeekPlanner/UnplannedTasks`, {
        params: Object.assign(Object.assign({}, filters), { page: pageParam, take: WEEK_PLANNER_UNPLANNED_TASKS_PAGE_SIZE }),
    })
        .then(res => { var _a; return (_a = res.data) !== null && _a !== void 0 ? _a : []; }), {
        enabled: enabled && !!filters.userId && anyLevelSelected,
        getNextPageParam: (lastPage, allPages) => lastPage.length === WEEK_PLANNER_UNPLANNED_TASKS_PAGE_SIZE ? allPages.length : undefined,
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    const items = (_b = data === null || data === void 0 ? void 0 : data.pages.flat()) !== null && _b !== void 0 ? _b : [];
    return {
        items,
        error,
        isLoading,
        isFetching,
        isFetchingNextPage,
        refetch,
        fetchNextPage,
        hasNextPage: !!hasNextPage,
    };
};
